import MainLayout from '@/components/layout/MainLayout.vue';

export default {
    name: 'privacyPolicy',

    components: {
        MainLayout
    }
}